import LINKS_LIST from './list.json'
import StateStorage from '../../lib/state-storage'

class NavigationLinks {
  constructor(i18n) {
    this.list = {}
    const { country, language } = i18n
    const cacheKey = `pomeloNavigationLinks-new-${country}-${language}`

    const list = StateStorage.getLocalState(cacheKey)

    if (list) {
      this.list = list
    } else {
      Object.keys(LINKS_LIST).forEach((key) => {
        this.list[key] = LINKS_LIST[key].map((link) => ({
          ...link,
          as: this.localizeLink(i18n, link),
          listItems: link.listItems
            ? link.listItems.map((itemLink) => ({
                ...itemLink,
                as: this.localizeLink(i18n, itemLink),
              }))
            : null,
        }))
      })

      StateStorage.saveLocalState(cacheKey, this.list)
    }
  }

  localizeLink(i18n, link) {
    const { country, language } = i18n

    return `/${country}/${language}${link.as}`
  }

  getList() {
    return this.list
  }
}

export default NavigationLinks
